import { render, staticRenderFns } from "./banquan.vue?vue&type=template&id=e2b543ce&scoped=true"
import script from "./banquan.vue?vue&type=script&lang=js"
export * from "./banquan.vue?vue&type=script&lang=js"
import style0 from "./banquan.vue?vue&type=style&index=0&id=e2b543ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b543ce",
  null
  
)

export default component.exports